import React, { useContext } from 'react';

import { ALL_LANGUAGES } from '../../shop/language/constants';

export type LanguageContext = string;

const Ctx = React.createContext<LanguageContext>(ALL_LANGUAGES);

export const LanguageProvider = Ctx.Provider;
export const LanguageConsumer = Ctx.Consumer;

export function useLanguage(): LanguageContext {
    return useContext(Ctx);
}
